import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class TransmissionTypeSpecificationVehiclesValueObject extends ValueObject {
  #transmissionType

  constructor({transmissionType}) {
    super()
    this.#transmissionType = transmissionType
  }

  static empty() {
    return new TransmissionTypeSpecificationVehiclesValueObject({
      transmissionType: SpecificationVehiclesValueObject.empty()
    })
  }

  static createFromId({id}) {
    if (!SpecificationVehiclesValueObject.isValidId({id}))
      return TransmissionTypeSpecificationVehiclesValueObject.empty()

    const {TRANSMISSION_TYPES} = ConfigContext.get('vehicleSpecifications')

    const {icon, name} = TRANSMISSION_TYPES[id]

    return new TransmissionTypeSpecificationVehiclesValueObject({
      transmissionType: SpecificationVehiclesValueObject.createFromLiterals({icon, id, name})
    })
  }

  get icon() {
    return this.#transmissionType.icon
  }

  get id() {
    return this.#transmissionType.id
  }

  get name() {
    return this.#transmissionType.name
  }

  get value() {
    return this.#transmissionType.value
  }

  isEmpty() {
    return this.#transmissionType.isEmpty()
  }
}
